// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bahrain from '../_raw/flag/icon_flag_bahrain.png';

export default () => <img src={Bahrain} alt="Bahrain" />;
